'use strict';
const Slick = require('slick-carousel/slick/slick');
var slickSlider = $('.js-slick-slider');
import productTileCmp from './productTileCmp';

function init() {
    var productTileCmpObj = new productTileCmp();
    productTileCmpObj.init();
    $(document).trigger('producttiles.childevents');
    $(document).on('recommendations.loaded lastvisited.loaded recommendations.initPredictiveRecommendations', function(event, selector) {
        $(document).trigger('producttiles.loaded', '.pdp-slots');
    });
    var arrowConfig = {"appendArrows": "#slick-recommendation-arrow",
    "nextArrow": "<span role='button' tabindex='0' class='jcarousel-nav js-swiper-button-next recommendation-section__carousel-nav-item'><i class='icon-arrow-right'><span class='visually-hidden'>Next</span></i></span>",
    "prevArrow": "<span role='button' tabindex='0' class='jcarousel-nav js-swiper-button-prev recommendation-section__carousel-nav-item'><i class='icon-arrow-left'><span class='visually-hidden'>Prev</span></i></span>",
    };
    var pdpSlickSlider = $('.js-pdp-slick-slider');
    $(window).on('resize', function() {
        var viewportWidth = $(window).width();
        var $pdpDesktopImgSlider = $('#product-images #pdp-images-slider');
        var $pdpMobileImgSlider = $('#product-images #pdp-images-mobile-slider');
        var $pdpDesktopImgThumb = $('#product-images #pdp-images-thumbnail');

        if(viewportWidth > 991) {
            // if ($pdpMobileImgSlider.hasClass('slick-initialized')) {
            //     $pdpMobileImgSlider.slick('unslick');
            // }
            let params = {asNavFor: "#pdp-images-thumbnail", infinite: true};
            slidePDPMainImage($pdpDesktopImgSlider, true, params);
            params = {asNavFor: "#pdp-images-slider", arrows: false, infinite: false, slidesToShow: 9, focusOnSelect: true };
            slidePDPMainImage($pdpDesktopImgThumb, false, params);
            if (viewportWidth > 575 && !pdpSlickSlider.hasClass('slick-initialized') && pdpSlickSlider.find('li.grid-tile').length > 0) {
                $(pdpSlickSlider).slick(arrowConfig).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    $(document).trigger('swiperslideChangeTransitionEnd');
                });
            }
        } else {
            slidePDPMainImage($pdpMobileImgSlider);
        }
    });

    // With Attraqt flow
    if(pdpSlickSlider && pdpSlickSlider.find('li.grid-tile').length > 0) {
        $('.js-recommendation-section, .shopthelook-btn').removeClass('is--hidden');
        // Need to update the below logic for updating the 'Complete the look' primary image
        setTimeout(() => {
            $('.recommendation-primary-img').attr('src', $('#product-images .shopthelook-img .component-picture img').attr('srcset'));
        }, 300);
        $(pdpSlickSlider).slick(arrowConfig).on('afterChange', function(event, slick, currentSlide, nextSlide) {
            $(document).trigger('swiperslideChangeTransitionEnd');
        });
    }

    // Without Attraqt flow
    $(document).on('recommendations.loaded', function(event, selector) {
        var viewportWidth = $(window).width();
        if(pdpSlickSlider && pdpSlickSlider.find('li.grid-tile').length > 0) {
            $('.js-recommendation-section, .shopthelook-btn').removeClass('is--hidden');
            // Need to update the below logic for updating the 'Complete the look' primary image
            setTimeout(() => {
                $('.recommendation-primary-img').attr('src', $('#product-images .shopthelook-img .component-picture img').attr('srcset'));
            }, 300);
            $(pdpSlickSlider).slick(arrowConfig).on('afterChange', function(event, slick, currentSlide, nextSlide) {
                $(document).trigger('swiperslideChangeTransitionEnd');
            });
        }
    });

    if($(".js-hbanner-slick-slider .swiper-slide").length > 0) {
        $('.js-hbanner-slick-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            dots: false
        });
    }

    if($(".plp-slick-slider .swiper-slide").length > 0) {
        $('.plp-slick-slider').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow:
                "<i class='icon-arrow-left slick-prev pull-left slick-arrow'></i>",
            nextArrow:
                "<i class='icon-arrow-right slick-next pull-right slick-arrow'></i>"
        });
        $('.plp-slick-slider .slick-prev, .plp-slick-slider .slick-next').on('click', function(e) {
            e.preventDefault();   
            e.stopPropagation();  
        });
    }
}

/* slick slider for product images */
function slidePDPMainImage($selector, arrows = true, params = '', varWidth = false) {
    let arrowConfig = '';
    if (arrows == true) {
        arrowConfig = {
            arrows: true,
            nextArrow: "<span role='button' tabindex='0' class='slider-arrow-right'><i class='icon-arrow-right'><span class='visually-hidden'>Next</span></i></span>",
            prevArrow: "<span role='button' tabindex='0' class='slider-arrow-left'><i class='icon-arrow-left'><span class='visually-hidden'>Prev</span></i></span>",
        };
    }

    var pdpMainImageSlickOptions = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: varWidth,
        ...arrowConfig,
        ...params
    }

    !$selector.hasClass('slick-initialized') ? $selector.slick(pdpMainImageSlickOptions) : '';
}

function slidehomePageTopSectionCarousel($selector) {
    var homePageTopSectionCarousel = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    }
    !$selector.hasClass('slick-initialized') ? $selector.slick(homePageTopSectionCarousel) : '';
}
/* slick slider for size variants */
function slideSizeVariants($selector) {
    var sizeSlickOptions = {
        infinite: false,
        slidesToShow: 9,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            }
        ]
    }
    !$selector.hasClass('slick-initialized') ? $selector.slick(sizeSlickOptions) : '';
}

/* slick slider for length variants */
function slideLengthVariants($selector) {
    var lengthSlickOptions = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    }
    !$selector.hasClass('slick-initialized') ? $selector.slick(lengthSlickOptions) : '';
}

/* slick slider for top section filters */
function slidetopFiltersSection($selector, arrows = true) {
    let arrowConfig = '';
    if (arrows == true) {
        arrowConfig = {
            arrows: true,
            nextArrow: "<span role='button' tabindex='0' class='slider-arrow-right'><i class='icon-arrow-right'><span class='visually-hidden'>Next</span></i></span>",
            prevArrow: "<span role='button' tabindex='0' class='slider-arrow-left'><i class='icon-arrow-left'><span class='visually-hidden'>Prev</span></i></span>",
        };
    }
    var topFiltersSlickOptions = {};
    if($selector.parents('.js-filter-price').length > 0) {
        topFiltersSlickOptions = {
            infinite: false,
            slidesToShow: 4,
            arrows: false,
            swipeToSlide: true,
            ...arrowConfig,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        variableWidth: true,
                        rows: 1,
                        swipeToSlide: true,
                        ...arrowConfig
                    }
                }
            ]
        }
    } else {
        topFiltersSlickOptions = {
            infinite: false,
            slidesToShow: 4,
            arrows: false,
            swipeToSlide: true,
            ...arrowConfig,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        variableWidth: true,
                        rows: 1,
                        swipeToSlide: true,
                        ...arrowConfig
                    }
                }
            ]
        }
    }
    
    !$selector.hasClass('slick-initialized') ? $selector.slick(topFiltersSlickOptions) : '';
}

module.exports = {
    slidehomePageTopSectionCarousel: slidehomePageTopSectionCarousel,
    slideSizeVariants: slideSizeVariants,
    slideLengthVariants: slideLengthVariants,
    slidePDPMainImage: slidePDPMainImage,
    //slidetopFiltersSection: slidetopFiltersSection,
    init
}